export function pluralize(str: string, count: number = 0, plural?: string) {
  if (count === 1) return str;
  return plural ?? str + "s";
}
